var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10H11.3062C11.5522 10 11.6752 10 11.7742 10.0452C11.8614 10.0851 11.9353 10.1492 11.9871 10.2299C12.0459 10.3215 12.0633 10.4433 12.0981 10.6869L12.5714 14M12.5714 14L13.6233 21.7314C13.7568 22.7125 13.8235 23.2031 14.0581 23.5723C14.2648 23.8977 14.5611 24.1564 14.9114 24.3174C15.3089 24.5 15.8039 24.5 16.7941 24.5H25.352C26.2945 24.5 26.7658 24.5 27.151 24.3304C27.4905 24.1809 27.7818 23.9398 27.9923 23.6342C28.2309 23.2876 28.3191 22.8247 28.4955 21.8988L29.8191 14.9497C29.8812 14.6238 29.9122 14.4609 29.8672 14.3335C29.8278 14.2218 29.7499 14.1277 29.6475 14.068C29.5308 14 29.365 14 29.0332 14H12.5714ZM18 29C18 29.5523 17.5523 30 17 30C16.4477 30 16 29.5523 16 29C16 28.4477 16.4477 28 17 28C17.5523 28 18 28.4477 18 29ZM26 29C26 29.5523 25.5523 30 25 30C24.4477 30 24 29.5523 24 29C24 28.4477 24.4477 28 25 28C25.5523 28 26 28.4477 26 29Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5013",
    x: 0,
    y: 0,
    width: 41.8887,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5013",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d30b55df708ab5da9532a070a039b652.svg";
export { ForwardRef as ReactComponent };